"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageMode = getPageMode;
exports.whenRouterChange = whenRouterChange;
exports.observeCallback = observeCallback;
exports.recordPagePerformance = recordPagePerformance;

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.find");

var firebase = _interopRequireWildcard(require("firebase/app"));

var _urlParse = _interopRequireDefault(require("url-parse"));

var _lodash = _interopRequireDefault(require("lodash"));

var _index = require("../constants/index");

var _utils = require("../utils");

var _runtime = _interopRequireWildcard(require("../utils/runtime"));

var _path = require("../utils/path");

var _device = require("../utils/device");

var _index2 = require("../compatibility/index");

var _transport = require("../transport");

var _index3 = _interopRequireDefault(require("../logger/index"));

var _mutationObserver = require("../mutationObserver");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var lastPageLeave = 0;
var recordFnCalled = false;
var isRouterHasChange = false;
var isFirstPageRecorded = false;
var recordOpts = {
  needNetResource: true,
  isFirstPage: false
};
var finalLoadingInfo = {
  startTime: 0,
  responseEnd: 0
}; // loading 结束后首次 mutation observe callback 被回调时间

var mutationTime = 0;
var maybePaintTime = 0;
var pageDidMountTime = 0; // 检查数据完整性 interval

var checkDataInterval;
var checkDataTimes = 0;
var MAX_TIMES = 10;
var DOM_COMPLETE_DELAY = 5000;
var CHECK_DELAY = 1000;

function getPageMode() {
  if ((0, _runtime.isOfflineEnv)()) {
    return _index.OFFLINE_MODE;
  } // 路由切换都认为是 csr 的情况


  if (isRouterHasChange) {
    return _index.EXPORT_MODE;
  }

  var pageMode = _runtime.default.get('pageMode');

  if (window.AL_SSR_DOWNGRADE) {
    return _index.DOWNGRADE_MODE;
  }

  return pageMode;
}

function isSSRMode() {
  return getPageMode() === _index.SSR_MODE;
}

function getMaxAPIResponseEnd(infos) {
  return Math.max.apply(Math, _toConsumableArray(infos.map(function (info) {
    return info.responseEnd;
  })));
}

function clearCheckInterval() {
  clearInterval(checkDataInterval);
  checkDataInterval = undefined;
}

function resetVars() {
  recordFnCalled = false;
  finalLoadingInfo = {
    startTime: 0,
    responseEnd: 0
  };
  mutationTime = 0;
  maybePaintTime = 0;
  pageDidMountTime = 0;
  checkDataTimes = 0;
}

function isBlankReady() {
  var blank = getBlankTime();
  return typeof blank !== 'undefined';
}

function isDomComplete() {
  return performance.timing.domComplete !== 0;
}

function isRenderReady() {
  return mutationTime > 0;
}

function isLoadingReady(opts) {
  var _checkLoadingInfosFul = checkLoadingInfosFulfilled(opts),
      ok = _checkLoadingInfosFul.ok,
      infos = _checkLoadingInfosFul.infos;

  return ok;
}

function isDataPrepared(opts) {
  var blankReady = isBlankReady(); // 如果是 CSR 模式，不需要使用domComplete ，直接设置为 true

  var domComplete = isSSRMode() ? isDomComplete() : true;
  var renderReady = isRenderReady();
  var loadingReady = isLoadingReady(opts);

  if (opts.criticalAPI && opts.criticalAPI.length > 0) {
    return blankReady && domComplete && loadingReady && renderReady;
  }

  return blankReady && domComplete;
}
/**
 *
 * @param {RecordPagePerfOptions} opts
 */


function startCheckData(opts) {
  checkDataInterval = setInterval(function () {
    if (checkDataTimes >= MAX_TIMES) {
      clearCheckInterval(); //计算关键任务

      checkLoadingInfosFulfilled(opts); // 多次检查后，依然没有 loading, mutation 等信息，也进行上报

      (0, _mutationObserver.stopObserver)();
      doRecord(opts);
      return false;
    }

    if (isDataPrepared(opts)) {
      clearInterval(checkDataInterval);
      checkDataTimes = 0;
      doRecord(opts);
    } else {
      checkDataTimes += 1;
    }
  }, CHECK_DELAY);
}
/**
 *
 * @param {RecordPagePerfOptions} opts
 */


function doRecord(opts) {
  var routeName = (0, _path.getRouteName)();

  if ((0, _runtime.isOfflineEnv)()) {
    // 离线包的情况都是 CSR 渲染
    recordCSRPagePerformance(routeName, opts, "off");
  } else {
    // 路由切换都认为是 csr 的情况
    if (isSSRMode() && !isRouterHasChange) {
      recordSSRPagePerformance(routeName, opts);
    } else {
      recordCSRPagePerformance(routeName, opts);
    }
  }
}

function getAPIResources() {
  return performance.getEntriesByType('resource').filter(function (r) {
    return r.initiatorType === 'xmlhttprequest' || r.initiatorType === 'fetch';
  });
}
/**
 *
 * @param {string} url
 * 获取匹配 url 的 api performance entry
 * @return undefined | PerformanceResourceEntry
 */


function getAPIEntry(url) {
  var parsed = (0, _urlParse.default)(url);
  var pathname = parsed.pathname;
  var apis = getAPIResources();
  var apiEntry = apis.find(function (entry) {
    var p = (0, _urlParse.default)(entry.name); // 前端路由切换，同一资源可能出现多次，因此判断此资源开始时间是否在页面离开之后，如果是首次加载，lastPageLeave 为 0，亦可用于此处

    return p.pathname === pathname && entry.startTime > lastPageLeave;
  });
  return apiEntry;
}
/**
 *
 * @param {RecordPagePerfOptions} opts
 * 获取所有关键接口的 api performance entry
 * @return null | Array<LoadingInfo>
 */


function getLoadingInfos(opts) {
  var criticalAPI = opts.criticalAPI;

  if (criticalAPI && typeof criticalAPI === 'string') {
    var entry = getAPIEntry(criticalAPI);

    if (entry) {
      return [{
        startTime: entry.startTime,
        responseEnd: entry.responseEnd
      }];
    }

    return null;
  }

  if (criticalAPI && Array.isArray(criticalAPI)) {
    var entries = criticalAPI.map(function (url) {
      var entry = getAPIEntry(url);

      if (entry) {
        return {
          startTime: entry.startTime,
          responseEnd: entry.responseEnd
        };
      }

      return null;
    });
    return entries;
  }

  return null;
}

function getTimeOrigin() {
  return isRouterHasChange ? lastPageLeave : performance.timeOrigin;
}
/**
 *
 * @param {LoadingInfos} infos
 * 记录最终的 loading 开始与结束时间
 */


function setFinalLoadingInfo(infos) {
  finalLoadingInfo = {
    startTime: Math.min.apply(Math, _toConsumableArray(infos.map(function (info) {
      return info.startTime;
    }))),
    responseEnd: getMaxAPIResponseEnd(infos)
  };
}
/**
 *
 * @param {RecordPagePerfOptions} opts
 * @return {{ ok: boolean; infos: LoadingInfos }}
 * 检查 loading 数据是否已完全获取到
 */


function checkLoadingInfosFulfilled(opts) {
  var infos = getLoadingInfos(opts);

  if (infos && !infos.includes(null)) {
    setFinalLoadingInfo(infos);
    return {
      ok: true,
      infos: infos
    };
  }

  return {
    ok: false,
    infos: infos
  };
}
/**
 *
 * @param {RecordPagePerfOptions} opts
 */


function getAttributes(opts) {
  return {
    mode: getPageMode(),
    need_net_resource: opts.needNetResource ? 'true' : 'false',
    device_level: (0, _device.getDeviceLevel)()
  };
}

function getBlankTime() {
  return (0, _utils.tryCall)(function () {
    return performance.getEntriesByType('paint').find(function (i) {
      return i.name === "first-paint";
    }).startTime;
  });
}

function getRenderTime() {
  // loading 完成后可能也没有触发 render，比如未登录情况下，只有一个在 body 内的 toast 出现，因此 mutationTime 一直为0
  if (finalLoadingInfo.responseEnd > 0 && mutationTime === 0) {
    return 0;
  } // performance.now 不可用时，mutationTime 是 Date.now()，是个时间戳，因此需要先减去 timeOrigin 来获取差值，再减去 responseEnd，获得 render 时间


  return (0, _index2.performanceNowAvailable)() ? mutationTime - finalLoadingInfo.responseEnd : mutationTime - performance.timeOrigin - finalLoadingInfo.responseEnd;
}

function getInteger(num) {
  return (0, _utils.safeComputeInteger)(function () {
    return num;
  });
}

function getSSRMetrics() {
  var blank = getBlankTime();
  var loading = finalLoadingInfo.responseEnd - finalLoadingInfo.startTime;
  var render = getRenderTime();
  var interactive = blank + loading + render;
  var ready = performance.timing.domComplete - performance.timing.navigationStart;
  return {
    blank: getInteger(blank),
    loading: getInteger(loading),
    render: getInteger(render),
    interactive: getInteger(interactive),
    ready: getInteger(ready)
  };
}

function getCSRInteractiveTime(_ref) {
  var blank = _ref.blank,
      loading = _ref.loading,
      render = _ref.render;
  var interactive = 0; // 标记为首页的取全部时间，不需要减去之前页面的离开时间

  if (recordOpts.isFirstPage && !isFirstPageRecorded) {
    if (loading === 0 && render === 0) {
      // performance.now 不可用时，pageDidMountTime 是 Date.now()，是个时间戳，差值需减去 timeOrigin 来获取
      // 当 loading 和 render 都为0（即没有关键接口时，可交互为当前页面componentDidMount时间）
      interactive = (0, _index2.performanceNowAvailable)() ? pageDidMountTime : pageDidMountTime - performance.timeOrigin;
    } else if (loading !== 0 && render === 0) {
      // 有关键接口，loading 不为0，但是没有触发 render 的情况，可交互时间为关键接口请求结束时间
      interactive = finalLoadingInfo.responseEnd;
    } else {
      // 此处为 loading, render 都有值，那么可交互时间就是 render 触发时间
      // performance.now 不可用时，mutationTime 是 Date.now()，是个时间戳，差值需减去 timeOrigin 来获取
      interactive = (0, _index2.performanceNowAvailable)() ? mutationTime : mutationTime - performance.timeOrigin;
    }
  } else {
    if (loading === 0 && render === 0) {
      // 当 loading 和 render 都为0（即没有关键接口时，可交互为 首次渲染时间）
      interactive = blank;
    } else if (loading !== 0 && render === 0) {
      // 有关键接口，loading 不为0，但是没有触发 render 的情况，可交互时间为关键接口请求结束时间减去上个页面离开时间
      // performance.now 不可用时，lastPageLeave 是 Date.now()，是个时间戳，差值需减去 timeOrigin 来获取
      interactive = isRouterHasChange ? finalLoadingInfo.responseEnd - ((0, _index2.performanceNowAvailable)() ? lastPageLeave : lastPageLeave - performance.timeOrigin) : finalLoadingInfo.responseEnd;
    } else {
      // 此处为 loading, render 都有值，那么可交互时间就是 render 触发时间
      // performance.now 不可用时，mutationTime 是 Date.now()，是个时间戳，差值需减去 timeOrigin 来获取
      // interactive = performanceNowAvailable() ? mutationTime : mutationTime - getTimeOrigin()
      interactive = (0, _index2.performanceNowAvailable)() ? mutationTime - (isRouterHasChange ? lastPageLeave : 0) : mutationTime - getTimeOrigin();
    }
  }

  return interactive;
}

function getCSRMetrics() {
  var blank = getBlankTime();

  if (isRouterHasChange) {
    blank = maybePaintTime - lastPageLeave;
  }

  var loading = finalLoadingInfo.responseEnd - finalLoadingInfo.startTime;
  var render = getRenderTime();
  var interactive = getCSRInteractiveTime({
    blank: blank,
    loading: loading,
    render: render
  });
  return {
    blank: getInteger(blank),
    loading: getInteger(loading),
    render: getInteger(render),
    interactive: getInteger(interactive)
  };
}

function pageMetricsValidator(value) {
  return value >= 0;
}
/**
 *
 * @param {string} routeName
 * @param {RecordPagePerfOptions} opts
 */


function recordSSRPagePerformance(routeName, opts) {
  var metrics = getSSRMetrics();
  var attributes = getAttributes(opts);
  recordFnCalled = (0, _transport.transport)({
    endPoints: [_index.FIREBASE_ENDPOINT_NAME, _index.PROMETHEUS_ENDPOINT_NAME],
    type: 'page_perf',
    traceName: "s_".concat(routeName),
    url: (0, _path.getUrl)(),
    message: {
      attributes: attributes,
      metrics: _objectSpread({
        duration: metrics.interactive
      }, _lodash.default.pick(metrics, ['blank', 'ready'])),
      metricsPredicate: pageMetricsValidator
    }
  });
}
/**
 *
 * @param {string} routeName
 * @param {RecordPagePerfOptions} opts
 */


function recordCSRPagePerformance(routeName, opts, prefix) {
  var metrics = getCSRMetrics();
  var attributes = getAttributes(opts);
  recordFnCalled = (0, _transport.transport)({
    endPoints: [_index.FIREBASE_ENDPOINT_NAME, _index.PROMETHEUS_ENDPOINT_NAME],
    type: prefix ? "".concat(prefix, "_page_perf") : 'page_perf',
    traceName: "".concat(prefix || 'c', "_").concat(routeName),
    url: (0, _path.getUrl)(),
    message: {
      attributes: _objectSpread({}, attributes, {
        is_route_change: isRouterHasChange ? 'true' : 'false',
        is_first_page: opts.isFirstPage && !isFirstPageRecorded ? 'true' : 'false'
      }),
      metrics: _objectSpread({
        duration: metrics.interactive
      }, _lodash.default.pick(metrics, ['blank', 'loading', 'render'])),
      metricsPredicate: pageMetricsValidator
    }
  }); // 只记录一个首页

  if (opts.isFirstPage && !isFirstPageRecorded) {
    isFirstPageRecorded = true;
  }
} // 页面切换 清空 recordFnCalled


function whenRouterChange() {
  // API 兼容性检查
  if (!(0, _index2.checkCompat)()) {
    return false;
  }

  lastPageLeave = (0, _utils.now)();
  isRouterHasChange = true; // checkDataInterval 存在表示上个页面的数据检查没有结束

  if (recordFnCalled || checkDataInterval) {
    // 上个页面 api 未完全加载的话，mutation observer 没有停止，先停止
    (0, _mutationObserver.stopObserver)(); // 正常情况下，observer 已被 disconnect，此时重新开始监听

    (0, _mutationObserver.startObserver)(observeCallback);
  } else {
    _index3.default.warn('recordPagePerformance 没有触发！');
  } // 路由切换后，如果上一个页面的数据还未获取到，直接丢弃上次上报


  if (checkDataInterval) {
    clearCheckInterval();
  }

  resetVars();
}

function observeCallback(mutationsList, ob) {
  var n = (0, _utils.now)();

  var _checkLoadingInfosFul2 = checkLoadingInfosFulfilled(recordOpts),
      ok = _checkLoadingInfosFul2.ok,
      infos = _checkLoadingInfosFul2.infos;

  if (ok && n > getMaxAPIResponseEnd(infos)) {
    mutationTime = n;
    (0, _mutationObserver.stopObserver)();
  }
}
/**
 *
 * @param {RecordPagePerfOptions} opts
 */


function recordPagePerformance(opts) {
  // API 兼容性检查
  if (!(0, _index2.checkCompat)()) {
    return false;
  }

  if (recordFnCalled) {
    _index3.default.warn('[performance-collect] recordPagePerformance 已经触发过了');

    return false;
  } // 路由切换的情况下，业务在 componentDidMount 内调用此函数的时间，即是白屏结束的时间


  if (maybePaintTime === 0) {
    maybePaintTime = (0, _utils.now)();
  }

  pageDidMountTime = (0, _utils.now)();
  recordOpts = opts;
  var currentRouteConfig = (0, _path.getRouteConfig)();

  if (currentRouteConfig.firebase && currentRouteConfig.firebase.enabled) {
    if (!isDataPrepared(opts)) {
      startCheckData(opts);
    } else {
      doRecord(opts);
    }
  }
}